import React, { useCallback, useEffect, useRef, useState } from "react";

import subCategoryViewModel from "./SubCategoryViewModel";

import { Button } from "primereact/button";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Image } from 'primereact/image';
import { InputText } from "primereact/inputtext";

import { FilterMatchMode } from "primereact/api";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import imgDefault from '../../../../assets/img/image_default_paket.jpg';
import './SubCategory.css';
 
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { classNames } from "primereact/utils";
import { Controller, useForm } from "react-hook-form";

import { IconName, library } from "@fortawesome/fontawesome-svg-core";
import categoryViewModel from "../../../Categories/Presentation/View/CategoryViewModel";

import {
  faBaby,
  faBath,
  faBriefcase,
  faCamera,
  faCarSide,
  faCompactDisc,
  faCouch,
  faDesktop,
  faDog,
  faDumbbell,
  faGamepad,
  faHeart,
  faHelmetSafety,
  faHouse,
  faLaptop,
  faOilCan,
  faPlug,
  faSatellite,
  faShirt,
  faTooth,
  faTree,
  faUser,
  faUserMd,
  faUtensils,
  faVirus,
  faWarehouse,
  faWeightHanging,
  faWineBottle,
  faScrewdriverWrench,
  faFire,
  faGear,
  faMobileScreen,
  faLightbulb,
  faSolarPanel,
  faCarBattery,
  faMusic,
  faBell,
  faPrint,
  faPen,
  faGift,
  faCameraRetro,
  faPalette,
  faClock,
  faWind
} from '@fortawesome/free-solid-svg-icons';
import { useToast } from "../../../../Shared/hook/useToast";

interface ColumnMeta {
  field: string;
  header: string;
  editable: boolean;
}

// let emptyProduct: SubCategory = {
//   name: '',
//   imageUrl: '',
//   categoryId: 0,

// };

interface IconList {
  name: string;
  icon: any;
  codeIcon: string;
}

export const SubCategoryView = ()=> {
  const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});
  //const [iconCodeState, setIconCodeState] = useState<string>();
   
 
  const { showSuccess, showError, showWarn, showInfo } = useToast();
  // const [categoryDataUpdate, setCategoryDataUpdate] = useState<SubCategory>(emptyProduct);
  const fileUploadRef = useRef<FileUpload>(null);
  const defaultValues = { 
    name: '',
    imageUrl: '',
    categoryId: 0,
  };
  const [visible, setVisible] = useState<boolean>(false);
  const {
    getSubCategories,
    createSubCategory,
    removeSubCategory,
    updateSubCategory,
    onChangeSubCategory,
    subCategories,
  } = subCategoryViewModel();
  const {
    getCategories,
    categories,
  } = categoryViewModel();
  
  const columns: ColumnMeta[] = [
      // {field: 'id', header: 'Id', editable: false},
      {field: 'name', header: 'Name', editable: true},
      {field: 'category', header: 'Categoría', editable: false},
      {field: 'imageUrl', header: 'Imagen', editable: false},
      {field: 'options', header: 'Opciones', editable: false},
  ];
  
      useEffect(() => {
        getSubCategories();
        getCategories();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);


    // const show = ( severity: any, summary: any, detail: any, life?: any) => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`, life: `${life}`});
    // };

    const accept = async (id: string) => {
      
        let deleted = await removeSubCategory(id);
        //console.log(deleted);
        if(deleted){
          showInfo('Confirmada', 'has aceptado');
          await getSubCategories();
        }
    }

    const reject = () => {
        showWarn('Rechazada', 'has rechazado');
    }

    const onSubmit = async(
        data: {
            name: string,
            imageUrl: string,
            categoryId: number,
        }
        ) => {

          // const formData = new FormData();

          // formData.append("name", data.name);
          // formData.append("categoryId", String(data.categoryId));
          // formData.append("image",data.imageUrl);
          
          
          try {
            // for (const [key, value] of formData.entries()) {
            //   console.log(`${key}:`, value);
            // }
          const response = await createSubCategory(data);
          if (response === true) {
            showSuccess("Se registro", "Se ha registrado con éxito!");
            await getSubCategories();
            reset();
            fileUploadRef.current?.clear(); 
          }

          
          
        } catch (error) {
          console.error("Error al enviar:", error);
        }
      };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

      const isUpdatingRef = useRef(false);
      const onCellEditComplete = useCallback(async (e: ColumnEvent) => {
        if (isUpdatingRef.current) return;
        isUpdatingRef.current = true;

        let { rowData, newValue, field, originalEvent: event } = e;

        // Validar vacío
        if (newValue === null || newValue === undefined || newValue === "") {
          event.preventDefault();
          isUpdatingRef.current = false;
          return;
        }

        // Evitar actualizar si no cambió
        if (rowData[field] === newValue) {
          event.preventDefault();
          isUpdatingRef.current = false;
          return;
        }

        const updatedRow = { ...rowData, [field]: newValue };

        await updateItemIName(updatedRow, field, event);

        isUpdatingRef.current = false;
      }, []);

      const updateItemIName = async ( item: any,  field: string, e: any) => {
      let addData: any;
        addData = {
          id: item.id,
          name: item.name,
          imageUrl: null,
          categoryId: item.categoryId
        }
        try {
        const data = await updateSubCategory(addData);

        if (data) {
          showSuccess("Se actualizo", "Se ha actualizado con éxito!");
          getSubCategories();
        }
      } catch (error) {
        console.error("Error al actualizar:", error);
        showError("Error", "No se pudo actualizar");
        e.preventDefault();
      }
    }

      const cellEditor = (options: ColumnEditorOptions) => {
          // if (options.field === 'icon') return viewIcons(options);
          // else return textEditor(options);
          return textEditor(options);
      };

      const textEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText 
                type="text" 
                value={options.value || ''}
                onChange={(e) => options.editorCallback!(e.target.value)} 
            />
        );
    };

      const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;
          let _filters = { ...filters };
          // @ts-ignore
          _filters['global'].value = value.toString() || '';

          setFilters(_filters);
          // setGlobalFilterValue(value);
      };


      const header = ()=>{
        // @ts-ignore
       const value = filters['global'] ? filters['global'].value : '';

       return (
           <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
               <h4 className="m-0">
                   <button type="button" className="btn btn-dark" onClick={() => setVisible(true)}>
                    <FontAwesomeIcon icon={icon({name: 'plus'})} /> 
                   Nueva sub categoría</button>

               </h4>
               <span className="p-input-icon-left">
                   <i className="pi pi-search" />
                   <InputText type="search" value={value || ''} onChange={(e) => 
                       onGlobalFilterChange(e)} placeholder="Buscar..." />
               </span>
           </div>
      )};

      const btnOptions = (id: string, name: string) => {

        return(
            <>
                <div className="d-flex">
                    <button onClick={()=>confirmDelete(id)} className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'trash'})} /></button>
                </div>
            </>
        );
    }

    const elementInputRefs = useRef<{ [id: string]: HTMLInputElement | null }>({});

 

    const updateItemImage = async (e: React.ChangeEvent<HTMLInputElement>, item: any) => {
      const file = e.target.files?.[0];
      
      let addData: any;
        
      if(file){
        addData = {
          id: item.id,
          name: item.name,
          imageUrl: file,
          categoryId: item.categoryId
        }
      }

      
        const data = await updateSubCategory(addData);

        if(data){
          await getSubCategories();
          showSuccess("Se registro", "Se ha actualizado con éxito!");
        }
        
      
    }

    const imgSubcat = (data: any)=>{
      // console.log("imgDefault", imgDefault);

      const imageSrc = data.imageUrl ? data.imageUrl : imgDefault;

            return(
                <>
                
              
               <div className="img-content">
                  <Image key={data.id +'pro'} src={imageSrc} alt="Image" width="100" onClick={() => elementInputRefs.current[data.id]?.click()} />
                   <input
                    ref={(el) => {
                      if (data.id) {
                        elementInputRefs.current[data.id] = el; // guardamos la referencia por id
                      }
                    }}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => updateItemImage(e, data)}
                  />
                </div>
               
              
                </>
            );
        }

    const confirmDelete = (id: string) => {

      confirmDialog({
          message: '¿Quieres eliminar este registro?',
          header: 'Eliminar confirmación',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => accept(id),
          reject
      });
  };
  const onCustomUpload = (files: any) => {
    const uploadedFiles = [...files];
    
    // Acceder al nombre del primer archivo (puedes ajustar según tus necesidades)
    const firstFileName = uploadedFiles.length > 0 ? uploadedFiles[0].name : null;
  
    // Realizar cualquier lógica adicional con el nombre del archivo
    // console.log('Nombre del primer archivo:', firstFileName);
  
    // Continuar con la carga predeterminada
    fileUploadRef.current?.upload();
  };

  const icons: IconList[] = [
      {name: 'bath', icon: 'bath', codeIcon: 'fas fa-bath'},
      {name: 'car-side', icon: 'car-side', codeIcon: 'fas fa-car-side'},
      {name: 'baby', icon: 'baby', codeIcon: 'fas fa-baby'},
      {name: 'plug', icon: 'plug', codeIcon: 'fas fa-plug'},
      {name: 'oil-can', icon: 'oil-can', codeIcon: 'fas fa-oil-can'},
      {name: 'laptop', icon: 'laptop', codeIcon: 'fas fa-laptop'},
      {name: 'utensils', icon: 'utensils', codeIcon: 'fas fa-utensils'},
      {name: 'weight-hanging', icon: 'weight-hanging', codeIcon: 'fas fa-weight-hanging'},
      {name: 'user-md', icon: 'user-md', codeIcon: 'fas fa-user-md'},
      {name: 'dog', icon: 'dog', codeIcon: 'fas fa-dog'},
      {name: 'dumbbell', icon: 'dumbbell', codeIcon: 'fas fa-dumbbell'},
      {name: 'warehouse',  icon: 'warehouse', codeIcon: 'fas fa-warehouse'},
      {name: 'house',  icon: 'house', codeIcon: 'fas fa-house'},
      {name: 'user',  icon: 'user', codeIcon: 'fas fa-user'},
      {name: 'heart',  icon: 'heart', codeIcon: 'fas fa-heart'},
      {name: 'camera',  icon: 'camera', codeIcon: 'fas fa-camera'},
      {name: 'tree',  icon: 'tree', codeIcon: 'fas fa-tree'},
      {name: 'gamepad',  icon: 'gamepad', codeIcon: 'fas fa-gamepad'},
      {name: 'shirt',  icon: 'shirt', codeIcon: 'fas fa-shirt'},
      {name: 'desktop',  icon: 'desktop', codeIcon: 'fas fa-desktop'},
      {name: 'virus',  icon: 'virus', codeIcon: 'fas fa-virus'},
      {name: 'wine-bottle',  icon: 'wine-bottle', codeIcon: 'fas fa-wine-bottle'},
      {name: 'tooth',  icon: 'tooth', codeIcon: 'fas fa-tooth'},
      {name: 'couch',  icon: 'couch', codeIcon: 'fas fa-couch'},
      {name: 'helmet-safety',  icon: 'helmet-safety', codeIcon: 'fas fa-helmet-safety'},
      {name: 'compact-disc',  icon: 'compact-disc', codeIcon: 'fas fa-compact-disc'},
      {name: 'satellite',  icon: 'satellite', codeIcon: 'fas fa-satellite'},
      {name: 'briefcase',  icon: 'briefcase', codeIcon: 'fas fa-briefcase'},
      {name: 'briefcase',  icon: 'briefcase', codeIcon: 'fas fa-briefcase'},
      {name: 'screwdriver-wrench',  icon: 'screwdriver-wrench', codeIcon: 'fas fa-screwdriver-wrench'},
      {name: 'fire',  icon: 'fire', codeIcon: 'fas fa-file'},
      {name: 'gear',  icon: 'gear', codeIcon: 'fas fa-gear'},
      {name: 'mobile-screen',  icon: 'mobile-screen', codeIcon: 'fas fa-mobile-screen'},
      {name: 'lightbulb',  icon: 'lightbulb', codeIcon: 'fas fa-lightbulb'},
      {name: 'solar-panel',  icon: 'solar-panel', codeIcon: 'fas fa-solar-panel'},
      {name: 'car-battery',  icon: 'car-battery', codeIcon: 'fas fa-car-battery'},
      {name: 'music',  icon: 'music', codeIcon: 'fas fa-music'},
      {name: 'bell',  icon: 'bell', codeIcon: 'fas fa-bell'},
      {name: 'print',  icon: 'print', codeIcon: 'fas fa-print'},
      {name: 'pen',  icon: 'pen', codeIcon: 'fas fa-pen'},
      {name: 'gift',  icon: 'gift', codeIcon: 'fas fa-gift'},
      {name: 'camera-retro',  icon: 'camera-retro', codeIcon: 'fas fa-camera-retro'},
      {name: 'palette',  icon: 'palette', codeIcon: 'fas fa-palette'},
      {name: 'clock',  icon: 'clock', codeIcon: 'fas fa-clock'},
      {name: 'wind',  icon: 'wind', codeIcon: 'fas fa-wind'},
    ];

    library.add(
        faWarehouse, 
        faCarSide, 
        faBaby,
        faPlug,
        faOilCan,
        faLaptop,
        faUtensils,
        faWeightHanging,
        faUserMd,
        faDog,
        faDumbbell,
        faBath,
        faHouse,
        faUser,
        faHeart,
        faCamera,
        faTree,
        faGamepad,
        faShirt,
        faDesktop,
        faVirus,
        faWineBottle,
        faTooth,
        faCouch,
        faHelmetSafety,
        faCompactDisc,
        faSatellite,
        faBriefcase,
        faScrewdriverWrench,
        faFire,
        faGear,
        faMobileScreen,
        faLightbulb,
        faSolarPanel,
        faCarBattery,
        faMusic,
        faBell,
        faPrint,
        faPen,
        faGift,
        faCameraRetro,
        faPalette,
        faClock,
        faWind
    );

    const categoryName = (data: any) => {

     const ico =  data.icon?.replace(/^fas\s+/, "") || "bath";
    
    return(
      <>
        <p className="icon-category-table"><FontAwesomeIcon key={data.icon} icon={[ 'fas', `${ico}` as IconName ]} /> {data.name}</p>
      </>
    );
  } 
    return (
      <>
        <div className="container-fluid">
          <div className="block-header">
              <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                      <h2>Lista sub categoría</h2>
                      <ul className="breadcrumb">
                          <li className="breadcrumb-item">
                              <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                          </li>
                          <li className="breadcrumb-item">Lista Sub categorías</li>
                      </ul>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="d-flex flex-row-reverse">
                          <div className="page_action">
                              {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                          </div>
                          <div className="p-2 d-flex">
                              
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="row">
              <div className='title-report'>
                  Aquí puedes ver las últimas sub categorías añadidas
              </div>
              {/* <InputSwitch  key={'index01254'} checked={checkedw} onChange={(e: InputSwitchChangeEvent) =>  setCheckedw(!checkedw)} /> */}
              
          </div>
          <div className='row'>
              <div className='col-lg-12'>
                {/* <Toast ref={toast} /> */}
                {/* <ConfirmDialog /> */}
                <DataTable 
                  value={subCategories!} 
                  paginator rows={5} 
                  editMode="cell" 
                  rowsPerPageOptions={[5, 10, 15, 20]} 
                  tableStyle={{    minWidth: '50rem' }}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                  // paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}  
                  globalFilterFields={['id', 'name']} emptyMessage="No customers found." stateStorage="session"
                  header={header} filters={filters} onFilter={(e) => setFilters(e.filters)}>
                    {columns.map(({ field, header, editable  }) => {
                            return <Column key={field} field={field} header={header}  
                            body=
                            {(rowData) => {
                                if (!rowData) return null; // Evitar errores si rowData es undefined
                        
                                switch (field) {
                                  
                                    case "imageUrl":
                                        return imgSubcat(rowData);
                                    case "category":
                                      return categoryName(rowData.category);
                                    case "options":
                                        return (
                                        <>
                                            {btnOptions(rowData.id , rowData.name)} 
                                            
                                        </>
                                    );
                                  default:
                                    return rowData[field]; // Mostrar el valor del campo en caso de no ser especial
                                }
                              }}
                            editor={editable ? (options) => cellEditor(options) : undefined} onCellEditComplete={onCellEditComplete} />
                    })}
                </DataTable>
                <Dialog header="Agregar subcategría" visible={visible} maximizable style={{ width: '400px' }} onHide={() => setVisible(false)}>
                      <form onSubmit={handleSubmit(onSubmit)} className="text-start" >
                        {/* <Toast ref={toast} /> */}
                        <div className="d-flex flex-column gap-2 ">
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: 'Nombre es requerido.' }}
                                render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name}>
                                        Nombre
                                    </label>
                                    <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                    {getFormErrorMessage(field.name)}
                                </>       
                            )}
                            />
                            <Controller
                                name="imageUrl"
                                control={control}
                                rules={{ required: 'Imagen es requerido.' }}
                                render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name}>
                                        Imagen
                                    </label>
                                     <p className="m-0 text-success">Peso: 1MB, tamaño: 800x800</p>
                                    <div className="card">
                                      {/* <InputText type="file"  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                      {getFormErrorMessage(field.name)} */}
                                      <FileUpload
                                          ref={fileUploadRef}
                                          mode="basic" 
                                          customUpload={true}
                                          chooseLabel="Subir"
                                          onUpload={(e) => {onCustomUpload(e.files[0])}}  
                                          onSelect={(e)=> {field.onChange(e.files[0])}}
                                          id={field.name} name={field.name}  accept="image/*" 
                                          maxFileSize={5000000}  
                                          className={classNames({ 'p-invalid': fieldState.invalid })}  />
                                    </div>
                                  {getFormErrorMessage(field.name)} 
                                </>       
                            )}
                            />
                            <Controller
                                  name="categoryId"
                                  control={control}
                                  rules={{ validate: value => value !== 0 || 'Categoría es requerido.' }}
                                  render={({ field, fieldState }) => (
                                  <>
                                      <label htmlFor={field.name}>
                                          Categoría
                                      </label>
                                      <Dropdown  id={field.name} name={field.name} value={field.value} focusInputRef={field.ref} 
                                      options={categories} optionLabel="name" optionValue="id" placeholder="Selecciona una categoría" className={classNames({ 'w-full md:w-14rem p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.value ? Number(e.value) : null)} />
                                      {getFormErrorMessage(field.name)}
                                  </>
                              )}
                            />
                            <Button label="Guardar" type="submit" icon="pi pi-check" className={"btn btn-dark"} />
                        </div>
                      </form>
                </Dialog>

              </div>
          </div>
        </div>
      </>
    );
}